export default __webpack_public_path__ + "static/media/notfound.42b65e21.svg";